export default "__VITE_ASSET__pKtCIdos__"